export enum ApplicantUserLogEnum {
    RegistrationSent = 0,
    Registered = 1,
    ApplicationSubmitted = 2,
    ApplicationAccepted = 3,
    ApplicationRejected = 4,
    ApplicationAmmende = 5,
}

export function ApplicantUserLogEnumToString(value: ApplicantUserLogEnum): string {
    switch (value) {
        case ApplicantUserLogEnum.RegistrationSent:
            return "Registration sent";
        case ApplicantUserLogEnum.Registered:
            return "Registered";
        case ApplicantUserLogEnum.ApplicationSubmitted:
            return "Application submitted";
        case ApplicantUserLogEnum.ApplicationAccepted:
            return "Application accepted";
        case ApplicantUserLogEnum.ApplicationRejected:
            return "Application rejected";
        case ApplicantUserLogEnum.ApplicationAmmende:
            return "Application ammends";
    }
}
